import {
    Button,
    capitalize,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormHelperText,
    Stack,
    Switch,
    TextField,
} from "@mui/material";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {usePhonenumbersHandling} from "../../hooks/phonenumbers/usePhonenumbersHandling";

interface Props {
    open: boolean;
    onClose: () => void;
}

export default function DialogCreatePhonenumber({open, onClose}: Props) {
    const {t: translation} = useTranslation('phonenumbers');
    const {createPhoneNumberMutation} = usePhonenumbersHandling();

    const [number, setNumber] = useState('');
    const [descriptor, setDescriptor] = useState('');
    const [isGlobal, setIsGlobal] = useState(false);

    useEffect(() => {
        if (open) {
            setNumber('');
            setDescriptor('');
            setIsGlobal(false);
        }
    }, [open]);

    const handleSubmit = async () => {
        try {
            await createPhoneNumberMutation.mutateAsync({
                number: number.trim(),
                descriptor: descriptor.trim() || null,
                isGlobal,
            });
            onClose();
        } catch {
            // error already surfaced via snackbar in the mutation hook
        }
    };

    const canSubmit = number.trim().length > 0 && !createPhoneNumberMutation.isLoading;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{capitalize(translation('phonenumber-create-dialog-title'))}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{pt: 1}}>
                    <TextField
                        label={capitalize(translation('phonenumber-number'))}
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        required
                        autoFocus
                        size="small"
                        fullWidth
                    />
                    <TextField
                        label={capitalize(translation('phonenumber-descriptor'))}
                        value={descriptor}
                        onChange={(e) => setDescriptor(e.target.value)}
                        size="small"
                        fullWidth
                    />
                    <div>
                        <FormControlLabel
                            control={<Switch checked={isGlobal} onChange={(e) => setIsGlobal(e.target.checked)} color="primary"/>}
                            label={capitalize(translation('phonenumber-fallback'))}
                        />
                        <FormHelperText>{translation('phonenumber-fallback-help')}</FormHelperText>
                    </div>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{capitalize(translation('abort'))}</Button>
                <Button variant="contained" color="secondary" onClick={handleSubmit} disabled={!canSubmit}>
                    {capitalize(translation('phonenumber-create'))}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
